import React, { useState, useEffect } from "react"
import axios from "axios"

import { notify } from "react-notify-toast"
import { Link } from "react-router-dom"
import AdminWrapper from "../Admin/AdminWrapper"
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar"
import { connect } from "react-redux"
import { setTeacher, setAllTeachers } from "../../redux/admin/admin.actions"

import TeacherInfoHeader from "../Admin/TeacherInfoHeader"
import { API } from "../../API"

import CheckableButton from "../../Components/CheckableButton/CheckableButton";
import { handleLogErrorToSlack, LIST_PAY_LEVEL_STATUS, PAY_LEVEL_STATUS } from "../../Helper"
import moment from "moment";
import FormDropdown from "../../Components/FormField/FormDropdown"
import { startCase } from 'lodash';
import Modal from "../../Components/Modal/Modal"
import ConfirmAndCancel from "../../Components/Buttons/ConfirmAndCancel"
import FormField from "../../Components/FormField/FormField"
import { getPresumedLevelName, TEACHING_QUAL_OVERSEAS_WITH_EXP, TEACHING_QUAL_AUSTRALIA_NO_EXP, TEACHING_QUAL_OVERSEAS_NO_EXP } from "../../Helper"

require("./ValidateDocuments.css")

const ValidateDocuments = (props) => {
  const user = JSON.parse(window.sessionStorage.getItem("admin-check-teacher")) || props.teacher;

  // const [allUsers, setAllUsers] = useState([])

  // const [isValidateBtn, setValidateBtn] = useState(false)

  const [wwccsize, wwccmeasure] = useState(0)
  const [polisize, polimeasure] = useState(0)
  const [visasize, visameasure] = useState(0)
  const [showConfirmModal, setShowConfirmModal] = useState(false)
  const [showRejectModal, setShowRejectModal] = useState(false)
  const [payLevelStatus, setPayLevelStatus] = useState(user?.pay_level?.status)
  const [reason, setReason] = useState("")
  const [presumedLevelNumber, setPresumedLevelNumber] = useState(3);
  const [hours, setHours] = useState("0:00");

  // const [sizelist, measurelist] = useState([])

  // const prelen = "https://n35tl2czql.execute-api.ap-southeast-2.amazonaws.com/default/getfile?path=".length
  const prelen = "https://zps3crms67.execute-api.ap-southeast-2.amazonaws.com/default/getfile3?path=".length

  let wwcc = ""
  let police_check = ""
  let visa = ""
  let qualifications = []
  let transcripts = []
  let uploadPoliceCheck,
    uploadVisa,
    uploadWWCC,
    uploadQualification = ""

  let [no_users, setNo_users] = useState("")

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    wwcc = document.querySelector(`#wwcc`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    police_check = document.querySelector(`#police_check`)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    visa = document.querySelector(`#visa`)
  })

  useEffect(() => {
    API.getTotalHoursOfTeacher(user._id)
      .then((res) => {
        const totalHours = res?.data?.data?.totalHours
        const hours = parseInt(totalHours)
        const minutes = parseInt((parseFloat(totalHours) % 1) * 60)
        setHours(hours.toString() + ":" + handleShowMinutes(minutes));
      })
      .catch((err) => {
        console.log(`⚡️[log]: †††††† ~ err: `, err);
      })
  }, []);

  const handleShowMinutes = (minutes) => {
    if (minutes >= 0 && minutes < 10) {
      return '0' + minutes;
    }

    return minutes
  }

  useEffect(() => {
    if (user) {
      if (user.wwcc_url) { sizeOfwwcc(user.wwcc_url.substring(prelen)); }
      if (user.police_check_url) { sizeOfpoli(user.police_check_url.substring(prelen)); }
      if (user.visa_url) { sizeOfvisa(user.visa_url.substring(prelen)); }
    }
  }, [user])

  const sizeOfwwcc = (key) => {
    API.sizeOf(key)
      .then(res => {
        wwccmeasure(res.data.size)
      })
  }

  const sizeOfpoli = (key) => {
    API.sizeOf(key)
      .then(res => {
        polimeasure(res.data.size)
      })
  }

  const sizeOfvisa = (key) => {
    API.sizeOf(key)
      .then(res => {
        visameasure(res.data.size)
      })
  }

  const handleValidation = (userId, user) => {
    debugger
    // const id = userId
    let newUser = Object.assign({}, user)
    let isWwcc_check_proof_url =
      user.wwcc_check_proof_url !== (null || undefined)
    let isPolice_check_proof_url =
      user.police_check_proof_url !== (null || undefined)
    let isVisa_check_proof_url = user.visa_url !== (null || undefined)

    if (wwcc && wwcc.checked) {
      if (isWwcc_check_proof_url) {
        newUser.wwcc_verification_status = wwcc.checked
        newUser.wwcc_check_validated_date = new Date()
        saveDocumentVerification(userId, newUser)
      } else {
        notify.show("Please provide wwcc verification proof", "warning")
      }
    }

    if (police_check && police_check.checked) {
      if (isPolice_check_proof_url) {
        newUser.police_check_verification_status = police_check.checked
        newUser.police_check_validated_date = new Date()
        saveDocumentVerification(userId, newUser)
      } else {
        notify.show("Please provide police verification proof", "warning")
      }
    }

    if (visa && visa.checked) {
      if (isVisa_check_proof_url) {
        newUser.visa_verification_status = true
        newUser.visa_check_validated_date = new Date()
        saveDocumentVerification(userId, newUser)
      } else {
        notify.show("Please provide visa verification proof", "warning")
      }
    }
  }

  const handleValidation_Qualification = (userId, index) => {
    let qualifications_id = []
    const list = user.qualifications
    const qualification_id = list.map((item) => item._id)
    for (var i = 0; i < qualification_id.length; i++) {
      qualifications_id[i] = qualification_id[i]
      qualifications = document.querySelector(`#${userId}`)
      transcripts = document.querySelector(`#${userId + index}`)
    }

    //debugger;

    let newUser = Object.assign({}, user)
    let isQualification_check_proof = user._id !== (null || undefined)
    if (qualifications && qualifications.checked) {
      if (isQualification_check_proof) {
        if (qualifications_id[index] === userId) {
          newUser.qualifications[index]["qualification_status"] = true
          newUser.qualification_check_validated_date = new Date()
          saveDocumentVerification(userId, newUser)
        }
      } else {
        notify.show("Please verify your qualification", "warning")
      }
    }

    let isTranscript_check_proof = user._id !== (null || undefined)
    if (transcripts && transcripts.checked) {
      if (isTranscript_check_proof) {
        if (qualifications_id[index] === userId) {
          newUser.qualifications[index]["transcript_status"] = true
          newUser.transcript_check_validated_date = new Date()
          saveDocumentVerification(userId, newUser)
        }
      } else {
        notify.show("Please verify your transcript", "warning")
      }
    }
  }
  const saveDocumentVerification = (userId, newUser, msg = "Email sent to user") => {
    const newAllUsers = props.all_users.map((u) => {
      if (u._id === userId) {
        u = newUser
      }
      return u
    })
    // setAllUsers(newAllUsers)
    // setUser(newUser)
    props.setAllTeachers(newAllUsers)
    props.setTeacher(newUser)
    // axios
    //   .put(`${PORT}/updateUser`, {
    //     user: newUser,
    //   })
    API.updateUser(newUser)
      .then((res) => {
        notify.show(msg)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  const uploadDocument = (id) => {
    document.getElementById(id).click()
  }

  const handleVisaFileChange = () => {
    debugger
    let visaFile = uploadVisa.files[0]
    //  saveFile(visaFile, "visa");
  }

  const handleWWCCFileChange = () => {
    let wwccFile = uploadWWCC.files[0]
    saveFile(wwccFile, "wwcc")
  }

  const handlePoliceCheckFileChange = () => {
    let policecheckFile = uploadPoliceCheck.files[0]
    saveFile(policecheckFile, "police")
  }

  const handleQualificationFileChange = (index) => {
    debugger
    let qualificationcheckFile = uploadQualification.files[0]
    let abc = "qualification" + index
    // saveFile(qualificationcheckFile, "qualification"+index);
  }

  const isShowLevelRateForDocs = () => {
    return TEACHING_QUAL_OVERSEAS_WITH_EXP === user?.pay_level?.category_name;
  }

  // Updates local storage object when any control updates its state
  // const updateLocalStorage = (field, value) => {
  //   let userData = JSON.parse(window.localStorage.getItem("teacher"));
  //   userData[`${field}`] = value;
  //   window.localStorage.setItem("teacher", JSON.stringify(userData));
  // };

  const updateTeacher = (field, value) => {
    let userData = props.teacher
    userData[field] = value
    props.setTeacher(userData)
  }

  const saveFile = (file, filename) => {
    let fileParts = file.name.split(".")
    let fileType = fileParts[1]
    let fileName = filename
    API.uploadFileToS3({
      fileName: `document-verification-files/verified-${fileName}`,
      fileType: fileType,
      _id: user._id,
    })
      .then((response) => {
        let newUser = Object.assign({}, user)
        let setState = ""
        const returnData = response.data.data.returnData
        const signedRequest = returnData.signedRequest
        const url = returnData.url

        let stateFileName = filename + "_check_proof_filename"
        let stateFileUrl = filename + "_check_proof_url"
        newUser[stateFileName] = file.name
        newUser[stateFileUrl] = url
        // setUser(newUser)
        props.setTeacher(newUser)
        // this.setState({ [stateFileName]: file.name });
        // this.setState({ [stateFileUrl]: url });
        // updateLocalStorage(stateFileName, file.name);
        // updateLocalStorage(stateFileUrl, url);
        updateTeacher(stateFileName, file.name)
        updateTeacher(stateFileUrl, url)
        // console.log("Signed request", signedRequest)
        // Put the fileType in the headers for the upload
        const options = {
          headers: {
            "Content-Type": fileType,
          },
        }
        axios
          .put(signedRequest, file, options)
          .then((response2) => {
            // alert("Good " + JSON.stringify(response2));
          })
          .catch((error) => {
            handleLogErrorToSlack(error, true)
            // alert("ERROR " + JSON.stringify(error));
          })
      })
      .catch((error) => {
        notify.show(JSON.stringify(error), "error")
      })
  }

  const setWatermarkedImage = (imgURL) => {
    // window.localStorage.setItem("imgURL", imgURL);
  }

  const toggleShowInSearch = (qual, type, show_in_search) => {
    let newUser = { ...user };
    let newQual = { ...qual };
    newQual.show_in_search = show_in_search;
    let newInfo = null;
    if (type === "elt") {
      newUser.qualifications = user.qualifications.map(q => {
        if (q._id === newQual._id) {
          return newQual;
        }
        else { return q; }
      })
      newInfo = {
        qualifications: newUser.qualifications
      }
    }
    else if (type === "training") {
      newUser.vet_training_quals = user.vet_training_quals.map(q => {
        if (q._id === newQual._id) {
          return newQual;
        }
        else { return q; }
      })
      newInfo = {
        vet_training_quals: newUser.vet_training_quals
      }
    }
    else if (type === "industry") {
      newUser.vet_industry_quals = user.vet_industry_quals.map(q => {
        if (q._id === newQual._id) {
          return newQual;
        }
        else { return q; }
      })
      newInfo = {
        vet_industry_quals: newUser.vet_industry_quals
      }
    }

    API.updateUserInfoByAdmin(newInfo, user._id).then(res => {
      props.setTeacher(newUser)
      let newAllUsers = [...props.all_users].map(u => {
        if (u._id === newUser._id) {
          return newUser;
        }
        else { return u; }
      });
      window.sessionStorage.setItem("admin-check-teacher", JSON.stringify(newUser))
      props.setAllTeachers(newAllUsers);
      notify.show("Qualification updated")

    })

    // API.updateUser({ user: newUser })
    //   .then(res => {
    //     props.setTeacher(newUser)
    //     let newAllUsers = [...props.all_users].map(u => {
    //       if (u._id === newUser._id) {
    //         return newUser;
    //       }
    //       else { return u; }
    //     });
    //     props.setAllTeachers(newAllUsers);
    //     notify.show("Qualification updated")

    //   })
  }

  const getQualificationsRow = (qual, type, index) => {
    return <tr
      key={index}
      className="availability-table-body-row"
    >
      {/* <td className="availability-table-cell">
                                  {user.degree} {user.major}
                                </td> */}
      <td className="availability-table-cell">
        {qual._id != null ? (
          qual.qualification_status ? (
            <div>
              {/* <a href={user.qualification_url} target="blank">Qualification File</a><br/> */}
              <Link
                to={{
                  pathname: `/NavigateToFileViewer?fileurl=${qual.qualification_url}`,
                }}
                target="_blank"
              >
                {/* <Link
                                          onClick={() => {
                                            setWatermarkedImage(
                                              user.qualification_url
                                            );
                                          }}
                                          to={{
                                            pathname: "/ImgWaterMarks"
                                          }}
                                          className="profile-linkfont"
                                          target="_blank"
                                        >*/}
                {qual.degree + ' ' + qual.award_name}
              </Link>
              {/*<small>Verified</small>*/}
            </div>
          ) : (
            <div>
              <div id="r8-balloon-radio-group-wrapper-teacherdetails">
                <ul>
                  <li>
                    <input
                      type="checkbox"
                      className="radio r8-radio-float"
                      id={qual._id}
                    ></input>
                  </li>
                </ul>
              </div>
              {/* <a href={user.qualification_url} target="blank">Qualification File</a> */}
              {/* <Link
                                          onClick={() => {
                                            setWatermarkedImage(
                                              user.qualification_url
                                            );
                                          }}
                                          to={{
                                            pathname: "/ImgWaterMarks"
                                          }}
                                          className="profile-linkfont"
                                          target="_blank"
                                        > */}
              <Link
                to={{
                  pathname: `/NavigateToFileViewer?fileurl=${qual.qualification_url}`,
                }}
                target="_blank"
              >
                {qual.degree}
              </Link>{" "}
              {qual.award_name}
            </div>
          )
        ) : (
          ""
        )}
      </td>
      <td className="availability-table-cell">
        {qual.institution_name}
      </td>
      <td className="availability-table-cell">
        {qual.transcript_url ? (
          qual.transcript_status ? (
            <div>
              {/* <a href={user.qualification_url} target="blank">Qualification File</a><br/> */}
              {/* <Link
                                          onClick={() => {
                                            setWatermarkedImage(
                                              user.transcript_url
                                            );
                                          }}
                                          to={{
                                            pathname: "/ImgWaterMarks"
                                          }}
                                          target="_blank"
                                        > */}
              <Link
                to={{
                  pathname: `/NavigateToFileViewer?fileurl=${qual.transcript_url}`,
                }}
                target="_blank"
              >
                {qual.degree}
              </Link>
              <small>Verified</small>
            </div>
          ) : (
            <div>
              <div id="r8-balloon-radio-group-wrapper-teacherdetails">
                <ul>
                  <li>
                    <input
                      type="checkbox"
                      className="radio r8-radio-float"
                      id={qual._id + index}
                    ></input>
                  </li>
                </ul>
              </div>
              {/* <Link
                                          onClick={() => {
                                            setWatermarkedImage(
                                              user.transcript_url
                                            );
                                          }}
                                          to={{
                                            pathname: "/ImgWaterMarks"
                                          }}
                                          target="_blank"
                                        > */}
              <Link
                to={{
                  pathname: `/NavigateToFileViewer?fileurl=${qual.transcript_url}`,
                }}
                target="_blank"
              >
                {qual.degree}
              </Link>
            </div>
          )
        ) : (
          ""
        )}
      </td>
      <td className="availability-table-cell">
        {qual.enrolment_url ? (
          qual.enrolment_status ? (
            <div>
              {/* <a href={user.qualification_url} target="blank">Qualification File</a><br/> */}
              {/* <Link
                                          onClick={() => {
                                            setWatermarkedImage(
                                              user.transcript_url
                                            );
                                          }}
                                          to={{
                                            pathname: "/ImgWaterMarks"
                                          }}
                                          target="_blank"
                                        > */}
              <Link
                to={{
                  pathname: `/NavigateToFileViewer?fileurl=${qual.enrolment_url}`,
                }}
                target="_blank"
              >
                {qual.degree}
              </Link>
              <small>Verified</small>
            </div>
          ) : (
            <div>
              <div id="r8-balloon-radio-group-wrapper-teacherdetails">
                <ul>
                  <li>
                    <input
                      type="checkbox"
                      className="radio r8-radio-float"
                      id={qual._id + index}
                    ></input>
                  </li>
                </ul>
              </div>
              {/* <Link
                                          onClick={() => {
                                            setWatermarkedImage(
                                              user.transcript_url
                                            );
                                          }}
                                          to={{
                                            pathname: "/ImgWaterMarks"
                                          }}
                                          target="_blank"
                                        > */}
              <Link
                to={{
                  pathname: `/NavigateToFileViewer?fileurl=${qual.enrolment_url}`,
                }}
                target="_blank"
              >
                {qual.degree}
              </Link>
            </div>
          )
        ) : (
          ""
        )}
      </td>
      <td className="availability-table-cell">
        <div className="input-icon d-flex justify-content-between ">
          <i className="mdi mdi-upload"></i>
          <input
            type="txt"
            className="form-control"
            placeholder={
              qual.wwcc_check_proof_filename
                ? qual.wwcc_check_proof_filename
                : "No file chosen"
            }
            disabled
          />
          <input
            type="file"
            id={"qualification_check_proof" + index}
            name="qualification_check_proof"
            onChange={() =>
              handleQualificationFileChange(index)
            }
            ref={(ref) => {
              //    `{index}uploadQualification`
              uploadQualification = ref
            }}
            style={{ display: "none" }}
            accept="image/*, .pdf"
          />
          <button
            id="btnUpload_qualification_proof"
            type="button"
            required
            className="ml-3 pl-5 pr-5 btn btn-primary btn-c primary-button-no-margin-hover"
            onClick={() =>
              uploadDocument(
                "qualification_check_proof" + index
              )
            }
          >
            Upload
                                    </button>
        </div>
      </td>
      <td className="availability-table-cell">
        <button
          className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
          onClick={() => {
            handleValidation_Qualification(
              qual._id,
              index
            )
          }} /*</td>onClick={()=>{handleValidation(user._id, index, user)}} id={'validateButton'+index} value={index}*/
          id={"validate" + index}
        >
          Validate
                                  </button>
      </td>
      <td className="availability-table-cell">
        <CheckableButton
          toggle
          noBorder
          // checked={user.is_searchable}
          // onChange={(e) => {
          //   props.updateSearchStatus(user._id, e.target.checked)
          // }}
          checked={qual.show_in_search}
          onChange={(e) => toggleShowInSearch(qual, type, e.target.checked)}
        />
      </td>

      {
        user?.is_childhood_teacher && qual?.graduation_date == "Present" ? (
          <td className="availability-table-cell">
            {
              qual?.is_completed_half_of_course
                ? <p>Yes</p>
                : <p>No</p>
            }
          </td>
        ) : (
          <td className="availability-table-cell"></td>
        )
      }
      
    </tr>
  }

  const updateTeacherPayLevel = () => {
    const admin = JSON.parse(JSON.parse(window.localStorage.getItem("persist:root"))?.user)?.user
    const preSumedLevel = isShowLevelRateForDocs() ? getPresumedLevelName(presumedLevelNumber) : user?.pay_level?.presumed_level;
    const newPayLevel = {
      reason: payLevelStatus === 'rejected' ? reason : '',
      status: payLevelStatus,
      teacher_id: user._id,
      presumed_level: preSumedLevel === 'Unknown' ? user.level : preSumedLevel?.toLocaleLowerCase()
    }
    setShowRejectModal(false);
    setShowConfirmModal(false)
    API.acceptOrRejectDocument(newPayLevel).then(res => {
      let newUser = res.data.data;
      props.setTeacher(newUser)
      let newAllUsers = [...props.all_users].map(u => {
        if (u._id === newUser._id) {
          return newUser;
        }
        else { return u; }
      });
      window.sessionStorage.setItem("admin-check-teacher", JSON.stringify(newUser))
      props.setAllTeachers(newAllUsers);
      notify.show("Update teacher pay level successfully!")
    })
  }

  return (
    <AdminWrapper>
      <SwitchMenuBar isViewAsTeacher />
      <div className="auth-right d-lg-flex bg-photoregister ">
        <div className="bg-gradient"></div>
        <div className="profile-container">
          <div className="profile-content-card-area">
            <div className="tab-content clearfix">
              <TeacherInfoHeader user={user} />
              <div className="mt-5">

                {/* navigationbar on top */}
                <div className="userNavigation d-flex justify-content-between">
                  <Link
                    to={{
                      pathname: "/TeacherPayLevelUpload",
                    }}
                    className="user-links text-center d-flex  btn-primary primary-button-no-margin-hover text-white"
                  >
                    <p>BACK</p>
                  </Link>
                  <div className="behind-user-links">
                    <Link
                      to={
                        {
                          pathname: "/TeacherNotes"
                        }
                      }
                      className="user-links  d-flex user-links-background-transparent "
                    >
                      <p>Team Notes</p>
                    </Link>
                  </div>
                  <div className="behind-user-links">
                    <Link
                      to={
                        {
                          pathname: "/TeacherpersonalDetails"
                        }
                      }
                      className="user-links d-flex user-links-background-transparent "
                    >
                      <p>P.Info/I.D.</p>
                    </Link>
                  </div>
                  <div className="behind-user-links">
                    <Link
                      to={{
                        pathname: "/TeacherBanking",
                      }}
                      className="user-links text-center d-flex  "
                    >
                      <p>Banking</p>
                    </Link>
                  </div>
                  <div className="behind-user-links">
                    <Link
                      to={{
                        //pathname: "",
                      }}
                      className="user-links user-links-active text-center d-flex "
                    >
                      <p>Uploads</p>
                    </Link>
                  </div>
                  <div className="behind-user-links">
                    <Link
                      to={{
                        pathname: "/QualificationUploaded",
                      }}
                      className="user-links text-center d-flex "
                    >
                      <p>Qualifications Uploaded</p>
                    </Link>
                  </div>
                  <div className="behind-user-links">
                    <Link
                      to={{
                        pathname: "/TeacherCalendar",
                      }}
                      className="user-links text-center d-flex "
                    >
                      <p>Calendar</p>
                    </Link>
                  </div>
                  <div className="behind-user-links">
                    <Link
                      to={{
                        pathname: "/TeacherJoblistAdmin",
                      }}
                      className="user-links text-center d-flex "
                    >
                      <p>JobList</p>
                    </Link>
                  </div>
                </div>

                {/* cpntent of the form */}
                <div className="availability-table-container">
                  <div className="availability-table">
                    {/* container of the form */}
                    <div className="availability-table-body  mb-0 mt-5">
                      <div className="availability-table-body-content h-100">
                        <table className="av-tab-root">
                          <thead className="availability-table-head">
                            <tr className="availability-table-head-row">
                              <th className="availability-table-head-cell">
                                WWCC
                              </th>
                              <th className="availability-table-head-cell">
                                Police Check
                              </th>
                              <th className="availability-table-head-cell">
                                Visa
                              </th>
                              {user.police_check_verification_status &&
                                user.visa_verification_status &&
                                user.wwcc_verification_status ? (
                                ""
                              ) : (
                                <th className="availability-table-head-cell">
                                  Validate
                                </th>
                              )}
                            </tr>
                          </thead>
                          <tbody className="availability-table-body-bodytable">
                            <tr className="availability-table-body-row">
                              <td className="availability-table-cell">
                                {user.wwcc_url != null ? (
                                  user.wwcc_verification_status ? (
                                    <div>
                                      <Link
                                        /* onClick={() => {
                                          setWatermarkedImage(user.wwcc_url);
                                        }} */
                                        to={{
                                          pathname: `/NavigateToFileViewer?fileurl=${user.wwcc_url}`,
                                          //   pathname: "/ImgWaterMarks"
                                        }}
                                        className="profile-linkfont-12"
                                        target="_blank"
                                      >
                                        {`WWCC File ${wwccsize}`}
                                      </Link>
                                      <br />
                                      <Link
                                        onClick={() => {
                                          setWatermarkedImage(
                                            user.wwcc_check_proof_url
                                          )
                                        }}
                                        to={{
                                          pathname: "/ImgWaterMarks",
                                        }}
                                        className="profile-linkfont-12"
                                        target="_blank"
                                      >
                                        WWCC Verification File
                                      </Link>
                                      <br />
                                      <small>Verified</small>
                                    </div>
                                  ) : (
                                    <table>
                                      <tr>
                                        <td>
                                          <div>
                                            <div id="r8-balloon-radio-group-wrapper-teacherdetails">
                                              <ul>
                                                <li>
                                                  <input
                                                    className="radio r8-radio-float"
                                                    type="checkbox"
                                                    id={"wwcc"}

                                                  //   onChange={setVerifyBtn}
                                                  ></input>
                                                </li>
                                              </ul>
                                            </div>
                                            <Link
                                              /* onClick={() => {
                                                  setWatermarkedImage(
                                                    user.wwcc_url
                                                  );
                                                }} */
                                              to={{
                                                pathname: `/NavigateToFileViewer?fileurl=${user.wwcc_url}`,
                                              }}
                                              className="profile-linkfont"
                                              target="_blank"
                                            >
                                              {`WWCC File ${wwccsize}`}
                                            </Link>
                                            <div></div>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          {" "}
                                          {user.wwcc_check_proof_url ? (
                                            <a
                                              href={user.wwcc_check_proof_url}
                                              className="profile-linkfont"
                                              rel="noopener noreferrer"
                                              target="_blank"
                                            >
                                              WWCC verification file
                                            </a>
                                          ) : (
                                            <div className="form-group">
                                              <label className="w-100">
                                                <p className="float-left mb-0">
                                                  Upload WWCC verification proof
                                                </p>
                                              </label>
                                              <div className="input-icon d-flex justify-content-between ">
                                                <i className="mdi mdi-upload"></i>
                                                <input
                                                  type="txt"
                                                  className="form-control"
                                                  placeholder={
                                                    user.wwcc_check_proof_filename
                                                      ? user.wwcc_check_proof_filename
                                                      : "No file chosen"
                                                  }
                                                  disabled
                                                />
                                                <input
                                                  type="file"
                                                  id="wwcc_check_proof"
                                                  name="wwcc_check_proof"
                                                  onChange={() =>
                                                    handleWWCCFileChange()
                                                  }
                                                  ref={(ref) => {
                                                    uploadWWCC = ref
                                                  }}
                                                  style={{ display: "none" }}
                                                  accept="image/*, .pdf"
                                                />
                                                <button
                                                  id="btnUpload_wwcc_proof"
                                                  type="button"
                                                  required
                                                  className="ml-3 pl-5 pr-5 btn btn-primary btn-c primary-button-no-margin-hover"
                                                  onClick={() =>
                                                    uploadDocument(
                                                      "wwcc_check_proof"
                                                    )
                                                  }
                                                >
                                                  Upload
                                                </button>
                                              </div>
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    </table>
                                  )
                                ) : (
                                  ""
                                )}
                              </td>
                              <td className="availability-table-cell">
                                {user.police_check_url != null ? (
                                  user.police_check_verification_status ? (
                                    <div>
                                      <Link
                                        /* onClick={() => {
                                          setWatermarkedImage(
                                            user.police_check_url
                                          );
                                        }} */
                                        to={{
                                          pathname: `/NavigateToFileViewer?fileurl=${user.police_check_url}`,
                                        }}
                                        className="profile-linkfont-12"
                                        target="_blank"
                                      >
                                        {`Police Check File ${polisize}`}
                                      </Link>
                                      <br />
                                      <Link
                                        onClick={() => {
                                          setWatermarkedImage(
                                            user.police_check_proof_url
                                          )
                                        }}
                                        to={{
                                          pathname: "/ImgWaterMarks",
                                        }}
                                        className="profile-linkfont-12"
                                        target="_blank"
                                      >
                                        Police Check verification File
                                      </Link>
                                      <br />
                                      <small>Verified</small>
                                    </div>
                                  ) : (
                                    <table>
                                      <tr>
                                        <td>
                                          <div>
                                            <div id="r8-balloon-radio-group-wrapper-teacherdetails">
                                              <ul>
                                                <li>
                                                  <input
                                                    className="radio r8-radio-float"
                                                    type="checkbox"
                                                    id={"police_check"}

                                                  //     onChange={setVerifyBtn}
                                                  ></input>
                                                </li>
                                              </ul>
                                            </div>
                                            <Link
                                              /* onClick={() => {
                                                  setWatermarkedImage(
                                                    user.police_check_url
                                                  );
                                                }} */
                                              to={{
                                                pathname: `/NavigateToFileViewer?fileurl=${user.police_check_url}`,
                                              }}
                                              className="profile-linkfont"
                                              target="_blank"
                                            >
                                              {`Police Check File ${polisize}`}
                                            </Link>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          {" "}
                                          {user.police_check_proof_url ? (
                                            <a
                                              href={user.police_check_proof_url}
                                              className="profile-linkfont"
                                              rel="noopener noreferrer"
                                              target="_blank"
                                            >
                                              Police check verification file
                                            </a>
                                          ) : (
                                            <div className="form-group">
                                              <label className="w-100">
                                                <p className="float-left mb-0">
                                                  Upload police check
                                                  verification proof
                                                </p>
                                              </label>
                                              <div className="input-icon d-flex justify-content-between ">
                                                <i className="mdi mdi-upload"></i>
                                                <input
                                                  type="txt"
                                                  className="form-control"
                                                  placeholder={
                                                    user.police_check_proof_filename
                                                      ? user.police_check_proof_filename
                                                      : "No file chosen"
                                                  }
                                                  disabled
                                                />
                                                <input
                                                  type="file"
                                                  id="police_check_proof"
                                                  name="police_check_proof"
                                                  onChange={() =>
                                                    handlePoliceCheckFileChange()
                                                  }
                                                  ref={(ref) => {
                                                    uploadPoliceCheck = ref
                                                  }}
                                                  style={{ display: "none" }}
                                                  accept="image/*, .pdf"
                                                />
                                                <button
                                                  id="btnUpload_police_proof"
                                                  type="button"
                                                  required
                                                  className="ml-3 pl-5 pr-5 btn btn-primary btn-c primary-button-no-margin-hover"
                                                  onClick={() =>
                                                    uploadDocument(
                                                      "police_check_proof"
                                                    )
                                                  }
                                                >
                                                  Upload
                                                </button>
                                              </div>
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    </table>
                                  )
                                ) : (
                                  ""
                                )}
                              </td>
                              <td className="availability-table-cell">
                                {user.visa_url != null ? (
                                  user.visa_verification_status ? (
                                    <div>
                                      <Link
                                        /* onClick={() => {
                                          setWatermarkedImage(user.visa_url);
                                        }} */
                                        to={{
                                          pathname: `/NavigateToFileViewer?fileurl=${user.visa_url}`,
                                        }}
                                        className="profile-linkfont-12"
                                        target="_blank"
                                      >
                                        {`Visa File ${visasize}`}
                                      </Link>
                                      <br />
                                      <Link
                                        onClick={() => {
                                          setWatermarkedImage(
                                            user.visa_check_proof_url
                                          )
                                        }}
                                        to={{
                                          pathname: "/ImgWaterMarks",
                                        }}
                                        className="profile-linkfont-12"
                                        target="_blank"
                                      >
                                        Visa Verification File
                                      </Link>
                                      <br />
                                      <small>Verified</small>
                                    </div>
                                  ) : (
                                    <table>
                                      <tr>
                                        <td>
                                          {" "}
                                          <div>
                                            <div id="r8-balloon-radio-group-wrapper-teacherdetails">
                                              <ul>
                                                <li>
                                                  <input
                                                    className="radio r8-radio-float"
                                                    type="checkbox"
                                                    id={"visa"}
                                                  //     onChange={setVerifyBtn}
                                                  ></input>
                                                </li>
                                              </ul>
                                            </div>
                                            <Link
                                              /* onClick={() => {
                                                  setWatermarkedImage(
                                                    user.visa_url
                                                  );
                                                }} */
                                              to={{
                                                pathname: `/NavigateToFileViewer?fileurl=${user.visa_url}`,
                                              }}
                                              className="profile-linkfont"
                                              target="_blank"
                                            >
                                              {`Visa File ${visasize}`}
                                            </Link>
                                          </div>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>
                                          {" "}
                                          {user.visa_check_proof_url ? (
                                            <a
                                              href={user.visa_check_proof_url}
                                              rel="noopener noreferrer"
                                              className="profile-linkfont"
                                              target="_blank"
                                            >
                                              Visa verifiction file
                                            </a>
                                          ) : (
                                            <div className="form-group">
                                              <label className="w-100">
                                                <p className="float-left mb-0">
                                                  Upload visa verification proof
                                                </p>
                                              </label>
                                              <div className="input-icon d-flex justify-content-between ">
                                                <i className="mdi mdi-upload"></i>
                                                <input
                                                  type="txt"
                                                  className="form-control"
                                                  placeholder={
                                                    user.visa_check_proof_filename
                                                      ? user.visa_check_proof_filename
                                                      : "No file chosen"
                                                  }
                                                  disabled
                                                />
                                                <input
                                                  type="file"
                                                  id="visa_check_proof"
                                                  name="visa_check_proof"
                                                  onChange={() =>
                                                    handleVisaFileChange()
                                                  }
                                                  ref={(ref) => {
                                                    uploadVisa = ref
                                                  }}
                                                  style={{ display: "none" }}
                                                  accept="image/*, .pdf"
                                                />
                                                <button
                                                  id="btnUpload_visa_proof"
                                                  type="button"
                                                  required
                                                  className="ml-3 pl-5 pr-5 btn btn-primary btn-c primary-button-no-margin-hover"
                                                  onClick={() =>
                                                    uploadDocument(
                                                      "visa_check_proof"
                                                    )
                                                  }
                                                >
                                                  Upload
                                                </button>
                                              </div>
                                            </div>
                                          )}
                                        </td>
                                      </tr>
                                    </table>
                                  )
                                ) : (
                                  ""
                                )}
                              </td>
                              <td className="availability-table-cell">
                                {user.police_check_verification_status &&
                                  user.visa_verification_status &&
                                  user.wwcc_verification_status ? (
                                  ""
                                ) : (
                                  <button
                                    className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
                                    onClick={() => {
                                      handleValidation(user._id, user)
                                    }}
                                    id={"validateButton"}
                                    value={user._id}
                                  >
                                    Validate
                                  </button>
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <br />
                        <br />
                        {
                          user?.is_elt && (
                            <>
                              <table className="av-tab-root">
                                <thead className="availability-table-head">
                                  <tr className="availability-table-head-row">
                                    <th className="availability-table-head-cell w-25">
                                      Pay Level Category
                                    </th>
                                    <th className="availability-table-head-cell">
                                      Presumed Level
                                    </th>
                                    <th className="availability-table-head-cell">
                                      Previous Level
                                    </th>
                                    <th className="availability-table-head-cell">
                                      RT hours
                                    </th>
                                    <th className="availability-table-head-cell">
                                      Uploaded File
                                    </th>
                                    <th className="availability-table-head-cell">
                                      Status
                                    </th>
                                    <th className="availability-table-head-cell">
                                      Uploaded at
                                    </th>
                                    <th className="availability-table-head-cell">
                                      Confirm Level
                                    </th>
                                  </tr>
                                </thead>

                                {
                                  user?.pay_level && (
                                    <tbody className="availability-table-body-bodytable">
                                      <tr
                                        key={"pay-level"}
                                        className="availability-table-body-row"
                                      >
                                        <td className="availability-table-cell">
                                          {user?.pay_level?.category_name}
                                        </td>
                                        <td className="availability-table-cell">
                                          {!isShowLevelRateForDocs() && startCase(user?.pay_level?.presumed_level)}
                                         {' - '} {user?.pay_level?.presumed_level_number}
                                        </td>
                                        <td className="availability-table-cell">
                                          {!isShowLevelRateForDocs() && startCase(user?.pay_level?.previous_level)}
                                        </td>
                                        <td className="availability-table-cell">
                                          {hours} HRS
                                        </td>
                                        <td className="availability-table-cell">
                                          <Link
                                            to={{
                                              pathname: `/NavigateToFileViewer?fileurl=${user?.pay_level?.payslip_url || user?.pay_level?.letter?.letter_url || ""}`,
                                            }}
                                            target="_blank"
                                          >
                                            {user?.pay_level?.payslip_filename || user?.pay_level?.letter?.letter_filename ? <i className="mdi mdi-upload"></i> : 'None'}
                                            {user?.pay_level?.payslip_filename || user?.pay_level?.letter?.letter_filename || ""}
                                          </Link>
                                        </td>
                                        <td className="availability-table-cell">
                                          {startCase(user?.pay_level?.status)}
                                          <br/>
                                          {user?.pay_level?.status === PAY_LEVEL_STATUS.REJECTED && user?.pay_level?.rejected_reason ? 'Reason: ' + user?.pay_level?.rejected_reason : '' }
                                        </td>
                                        <td className="availability-table-cell">
                                          {moment(user?.pay_level?.uploaded_at).format('YYYY-MM-DD HH:mm:ss')}
                                        </td>
                                        <td className="availability-table-cell">
                                        <FormDropdown
                                          value={user?.pay_level?.status}
                                          onChange={(e) => {
                                            if (e.target.value !== user?.pay_level?.status) {
                                              setPayLevelStatus(e.target.value)

                                              if (e.target.value === PAY_LEVEL_STATUS.REJECTED) {
                                                setShowRejectModal(true)
                                              } 
                                              if (e.target.value === PAY_LEVEL_STATUS.ACCEPTED) {
                                                setShowConfirmModal(true)
                                              }
                                            }
                                          }}
                                          disabled={user?.pay_level?.category_name === TEACHING_QUAL_AUSTRALIA_NO_EXP || user?.pay_level?.category_name === TEACHING_QUAL_OVERSEAS_NO_EXP}
                                        >
                                          {
                                            LIST_PAY_LEVEL_STATUS.map(status => <option className="text-capitalize" value={status}>{startCase(status)}</option>)
                                          }
                                        </FormDropdown>
                                        </td>
                                      </tr>
                                    </tbody>
                                  )
                                }
                              </table>
                              <hr />
                            </>
                          )
                        }
                        <br />
                        <br />
                        <table className="av-tab-root">
                          <thead className="availability-table-head">
                            <tr className="availability-table-head-row">
                              <th className="availability-table-head-cell">
                                Qualification
                              </th>
                              <th className="availability-table-head-cell">
                                Institution Name
                              </th>
                              <th className="availability-table-head-cell">
                                Transcripts
                              </th>
                              <th className="availability-table-head-cell">
                                Enrolment
                              </th>
                              <th className="availability-table-head-cell">
                                Verification File
                              </th>
                              <th className="availability-table-head-cell">
                                Validate
                              </th>
                              <th className="availability-table-head-cell">
                                Search Card
                              </th>
                              {
                                user?.is_childhood_teacher && (
                                  <th className="availability-table-head-cell">
                                    Completed 50%?
                                  </th>
                                )
                              }
                            </tr>
                          </thead>

                          <tbody className="availability-table-body-bodytable">
                            {user.qualifications?.map((qual, index) => (
                              getQualificationsRow(qual, "elt", index)
                            ))}
                            {user.vet_training_quals?.map((qual, index) => (
                              getQualificationsRow(qual, "training", index)
                            ))}
                            {user.vet_industry_quals?.map((qual, index) => (
                              getQualificationsRow(qual, "industry", index)
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="availability-table-body-content">
                        <h1> {no_users} </h1>
                      </div>
                    </div>
                  </div>
                </div>
                {/* navigationbar on bottom */}
                <div className="adminBottomNavigation ">
                  <Link
                    to={{
                      pathname: "/AllTeachers",
                    }}
                    className="btn btn-primary btn-block btn-c primary-button-no-margin-hover"
                  >
                    <p>BACK - All Teachers</p>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <Modal
            header="CONFIRM ACCEPT PAY LEVEL"
            show={showConfirmModal}
            onClose={() => setShowConfirmModal(false)}
            className="confirm-number-modal w-50"
          >
            <div className="text-center">
              Are you sure to accept this pay level?
            </div>

           {isShowLevelRateForDocs() && <FormDropdown
            label="Select the presumed level of teacher:"
            id="presumed_level_number"
            name="presumed_level_number"
            onChange={(e) => setPresumedLevelNumber(e.target.value)}
            value={presumedLevelNumber}
            required
            // disabled={this.checkPayLevelUploaded()}
          >
            <option disabled value="">
              Please Select
            </option>
            {[3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 0].map((presumed_level) => {
              return <option key={presumed_level} value={presumed_level}>
                {presumed_level !== 0 ? `Level ${presumed_level}` : "Unknown"}
              </option>;
            })}
            </FormDropdown>}

            {
              isShowLevelRateForDocs() && (
                <p className="font-weight-bold mb-2">
                  Teacher's level will be {getPresumedLevelName(presumedLevelNumber)}.
                </p>
              )
            }

            <ConfirmAndCancel
              onCancel={() => {
                setShowConfirmModal(false)
              }}
              cancelText='No'
              onConfirm={() => updateTeacherPayLevel()}
              confirmText='Yes'
            />
          </Modal>
          <Modal
            header="CONFIRM REJECT PAY LEVEL"
            show={showRejectModal}
            onClose={() => setShowRejectModal(false)}
            className="reject-modal w-50"
          >

            <p className="mb-2">Reason</p>
            <FormField
              type="textarea"
              rows="3"
              id="reason"
              placeholder={
                "Please provide reason to reject this pay level"
              }
              onChange={(e) => setReason(e.target.value)}
              value={reason}
              required
            />

            <ConfirmAndCancel
              onCancel={() => {
                setShowRejectModal(false)
              }}
              cancelText='No'
              onConfirm={() => updateTeacherPayLevel()}
              confirmText='Yes'
            />
          </Modal>
        </div>
      </div>
    </AdminWrapper>
  )
}

function mapStateToProps(state) {
  return {
    teacher: state.admin.teacher,
    all_users: state.admin.all_users
  }
}

const mapDispatchToProps = {
  setTeacher, setAllTeachers
}

export default connect(mapStateToProps, mapDispatchToProps)(ValidateDocuments)